<template>
  <div id="app">
    <!--
    <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div>
    <router-view/>
-->
    <b-container>
      <b-jumbotron :style="linear_gradient">
        <img class="img-fluid" alt="nzsites" src="./assets/logo.png">
        <p class="my-5"><a :href="mailto">
            {{email}}
          </a>
        </p>
        <p><a :href="tel">
            {{phone}}</a>
        </p>
        <p class="">&copy; {{year}}</p>

        <b-button @click="colour_scheme" variant="outline-primary">New Colour
        </b-button>
      </b-jumbotron>
    </b-container>
  </div>
</template>


<script>
  export default {


    data() {
      return {
        start: 60,
        end: 230,
        max_delta: 60,
        deg: 275,
        rgb: [118, 83, 181, 0],
        rgb_end: [178, 142, 208, 20],
        phone: '+64 9 950-7301',
        email: 'sites@nzsites.nz'
      }
    },
    methods: {
      randrange(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
      },
      colour_scheme() {
        this.deg = this.randrange(20, 350);

        this.rgb = [this.randrange(this.start, this.end), this.randrange(this.start, this.end), this.randrange(this
          .start, this.end), 0];
        this.rgb_end = [this.rgb[0] + this.randrange(20, this.max_delta), this.rgb[1] + this.randrange(20, this
          .max_delta), this.rgb[2] + this.randrange(20, this.max_delta), this.randrange(20, 40)]
      },

    },
    mounted: function () {
      this.colour_scheme();
    }, 
    computed: {
      year() {
        return (new Date).getFullYear();
      },
      linear_gradient() {
        return `background-image: linear-gradient(${this.deg}deg, rgba(${this.rgb.join()}), rgba(${this.rgb_end.join()}));`
      },
      mailto() {
        return 'mailto:' + this.email
      },
      tel() {
        return 'tel:' + this.phone
      },
      showAlert() {
        return this.name.length > 4 ? true : false
      }
    }
  }
</script>

<style lang="scss">
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }

  #nav {
    padding: 30px;

    a {
      font-weight: bold;
      color: #2c3e50;

      &.router-link-exact-active {
        color: #42b983;
      }
    }
  }
</style>